module.exports = __webpack_public_path__ + "7ea734150075f342479a041217017df8.ttf";